import React, { useCallback } from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { ButtonLink } from '@shared/componentsStyled/Button'
import { yaCounter } from '@shared/pipes/ya-counter'
import styled, { CSSObject } from 'styled-components'

const logInvestLead = (): void => yaCounter.utils.reachGoal('invest_lead')

interface SectionStartProps {
	goToInvestorLk: () => void
}

export function SectionStart({ goToInvestorLk }: SectionStartProps) {
	const onRegisterClick = useCallback(() => {
		logInvestLead()
		goToInvestorLk()
	}, [])
	return (
		<Section>
			<ViewRoot>
				<TextTitle>Открыть Сбережение</TextTitle>
				<ViewRow>
					<ViewItem>
						<ImageStyled name='investStart1.png' alt='' />
						<Text>Пройдите регистрацию в личном кабинете и выберите условия</Text>
					</ViewItem>
					<ViewItem>
						<ImageStyled name='investStart2.png' alt='' />
						<Text>Подпишите документы электронной подписью не выходя из дома</Text>
					</ViewItem>
					<ViewItem last>
						<ImageStyled name='investStart3.png' alt='' />
						<Text>Переведите сумму сбережений и получайте выплаты в срок</Text>
					</ViewItem>
				</ViewRow>
				<ViewButtonRow>
					<ButtonLink onClick={onRegisterClick}>Зарегистрироваться</ButtonLink>
				</ViewButtonRow>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	marginBottom: 60,
	paddingLeft: 20,
	paddingRight: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 100,
		paddingLeft: 60,
		paddingRight: 60,
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const ViewRow = styled.div(
	({ theme }) =>
		({
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'flex-start',
			marginBottom: 30,
			[theme.mediaQueries.mediaMinWidthMobile]: {
				flexDirection: 'row',
				justifyContent: 'space-between',
				marginBottom: 40,
			},
		} as CSSObject)
)

interface ViewItemProps {
	last?: boolean
}

const ViewItem = styled.div<ViewItemProps>(({ theme, last = false }) => ({
	flex: 1,
	maxWidth: 240,
	marginRight: 0,
	marginBottom: last ? 0 : 30,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginRight: last ? 0 : 20,
		marginBottom: 0,
		justifyContent: 'space-between',
	},
}))

const ImageStyled = styled(Image)(({ theme }) => ({
	width: 240,
	marginBottom: 30,
	aspectRatio: '240/180',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 20,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))

const ViewButtonRow = styled.div(
	({ theme }) =>
		({
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			[theme.mediaQueries.mediaMinWidthMobile]: {
				flexDirection: 'row',
				justifyContent: 'flex-start',
				alignItems: 'center',
			},
		} as CSSObject)
)
